let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bIJ2r")).then(() => parcelRequire('a45cm'));